/**
 * How a Facebook tap's treat for the Facebook post sheet experiment ended, as the eligibility probe
 * reports it. `skipped`: the supporter was ineligible, so nothing was treated. `timed_out`: the treat
 * did not settle within the treat budget, so the tap went ahead with no exposure.
 */
export type FacebookPostSheetTreatOutcome = 'registered' | 'not_registered' | 'timed_out' | 'skipped';

/**
 * Module-level latches, keyed on the experiment name and never reset, shared by every `ShareSlideUp`
 * mount (PromoteOrShareActions and StickyComboCtaBar each mount one, with its own `useShareActions`).
 * A per-hook ref would allow one treat per mount; a `finally`-released ref or React state would allow a
 * second treat on a reopen. Both survive across mounts within the SPA session and reset on a full reload.
 */
export const facebookPostSheetTreats = new Map<string, Promise<'registered' | 'not_registered'>>();
export const firedFacebookPostSheetExposures = new Set<string>();
